// Phase 84.M.102 — Hero illustration banner shared cho tất cả flow upload
// ảnh OCR để duyệt điểm trình.
//
// Phase 85.A.69 — Tooltip overlay markers (user choice Q1c + Q2a):
//   • 2 markers số tròn (1, 2) overlay lên 2 vùng cần chú ý:
//     1️⃣ Họ tên đầy đủ (top row)
//     2️⃣ Điểm trình (cuối, số 2.659)
//   • Desktop (hover): tooltip popup khi hover marker
//   • Mobile (touch): always-visible callout chip kế bên marker
//   • Toggle qua `data-callout-mode` (CSS media query)
//
// Layout: hero full-bleed phía trên cùng modal/banner.
import React from "react";

export const RATING_VERIFY_MASCOT_URL =
  "https://customer-assets.emergentagent.com/job_853d5d2f-9821-481e-8a5c-dd480d334769/artifacts/sofx6q5o_02CAF160-5FEE-4BE1-B06D-5DEEB728096C.png";

// Phase 85.A.69 — Marker positions theo % aspect của ảnh mascot (1:1).
// Verified bằng ảnh URL: ảnh anime card kích thước ~1024x1024 với:
//   • Họ tên "Tên: Nguyễn ngọc..." nằm ở khoảng y=58% từ trên xuống.
//   • Điểm "Điểm đôi: 2.659" nằm ở y=78%.
const MARKERS = [
  {
    id: "name",
    label: "Họ tên đầy đủ",
    description: "Phải khớp với họ tên trong tài khoản PickLeague của bạn.",
    // x/y là % so với chiều rộng/cao ảnh.
    x: 52,
    y: 60,
    number: 1,
  },
  {
    id: "rating",
    label: "Điểm trình",
    description: "Điểm đôi/đơn hiển thị rõ ràng, số đầy đủ (ví dụ: 2.659).",
    x: 52,
    y: 80,
    number: 2,
  },
];

export default function RatingVerifyIllustration({
  className = "",
  maxHeight = 280,
  testId = "rating-verify-illustration",
  showMarkers = true,
}) {
  return (
    <div
      className={`relative w-full overflow-hidden rounded-xl bg-gradient-to-br from-sky-200/20 via-blue-100/10 to-amber-100/10 border border-white/10 ${className}`}
      data-testid={testId}
    >
      {/* Container giữ aspect-ratio 1:1 để markers nằm đúng vị trí % */}
      <div className="relative w-full mx-auto" style={{ maxWidth: maxHeight, aspectRatio: "1 / 1" }}>
        <img
          src={RATING_VERIFY_MASCOT_URL}
          alt="Ví dụ ảnh profile từ app có điểm trình"
          className="absolute inset-0 w-full h-full object-contain"
          loading="lazy"
        />
        {showMarkers && MARKERS.map((m) => (
          <Marker key={m.id} {...m} />
        ))}
      </div>
    </div>
  );
}

// Single marker — number badge + tooltip / callout chip.
function Marker({ id, label, description, x, y, number }) {
  return (
    <div
      className="absolute group"
      style={{ left: `${x}%`, top: `${y}%`, transform: "translate(-50%, -50%)" }}
      data-testid={`rating-marker-${id}`}
    >
      {/* Badge số tròn */}
      <div
        className="relative w-7 h-7 rounded-full flex items-center justify-center text-[12px] font-black text-white shadow-[0_4px_12px_rgba(255,138,0,0.6)] ring-2 ring-white/90 cursor-help select-none"
        style={{ background: "linear-gradient(135deg, #FF4D4F 0%, #FF8A00 100%)" }}
      >
        {number}
        {/* Pulse animation ring */}
        <span
          className="absolute inset-0 rounded-full animate-ping opacity-60"
          style={{ background: "rgba(255,138,0,0.4)" }}
        />
      </div>

      {/* Tooltip (desktop hover) — absolute over marker */}
      <div
        className="hidden md:group-hover:flex absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-20 flex-col items-center"
        role="tooltip"
        data-testid={`rating-marker-tip-${id}`}
      >
        <div className="bg-[#0B1220] text-white text-[11px] rounded-lg px-3 py-2 whitespace-nowrap shadow-[0_8px_24px_rgba(0,0,0,0.5)] border border-white/15 max-w-[200px]">
          <div className="font-black text-amber-300 mb-0.5">{label}</div>
          <div className="text-white/75 whitespace-normal leading-snug">{description}</div>
        </div>
        <div className="w-2 h-2 bg-[#0B1220] border-r border-b border-white/15 rotate-45 -mt-1" />
      </div>

      {/* Callout chip (mobile always-visible) — beside marker */}
      <div
        className="md:hidden absolute left-full ml-2 top-1/2 -translate-y-1/2 whitespace-nowrap pointer-events-none"
        data-testid={`rating-marker-chip-${id}`}
      >
        <div className="px-2 py-0.5 rounded-md bg-amber-500 text-white text-[10px] font-black shadow leading-tight">
          {label}
        </div>
      </div>
    </div>
  );
}
